// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"42e4e821","985":"ed9b29da"}[chunkId] + ".chunk.js";
};